export const GET_PAYMENT_INTEGRATION_SETTINGS_STARTED = "GET_PAYMENT_INTEGRATION_SETTINGS_STARTED"
export const GET_PAYMENT_INTEGRATION_SETTINGS_SUCCESS = "GET_PAYMENT_INTEGRATION_SETTINGS_SUCCESS"
export const GET_PAYMENT_INTEGRATION_SETTINGS_FAILURE = "GET_PAYMENT_INTEGRATION_SETTINGS_FAILURE"